import * as React from "react";
import { ErrorContext } from "./error-provider.mjs";
const useErrorLog = () => {
  return React.useContext(ErrorContext);
};
export {
  useErrorLog
};
